import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      componentStack: null,
      errorComponentProps: null,
      errorComponentState: null
    };
  }

  static getDerivedStateFromError(error) {
    return { 
      hasError: true,
      error: error
    };
  }

  componentDidCatch(error, errorInfo) {
    let componentProps = null;
    let componentState = null;
    
    try {
      if (this.props.children) {
        if (this.props.children.props) {
          componentProps = { ...this.props.children.props };
        }
        if (this.props.children.state) {
          componentState = { ...this.props.children.state };
        }
      }
    } catch (e) {
      console.warn('Could not capture component state:', e);
    }
    
    this.setState({
      error: error,
      errorInfo: errorInfo,
      componentStack: errorInfo?.componentStack,
      errorComponentProps: componentProps,
      errorComponentState: componentState
    });
  }

  render() {
    console.log('ErrorBoundary render - hasError:', this.state.hasError);
    
    if (this.state.hasError) {
      console.error('Error caught by ErrorBoundary:', this.state.error);
      console.error('Error info:', this.state.errorInfo);
      
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md m-4">
          <h2 className="text-lg font-semibold text-red-800">Something went wrong.</h2>
          <details className="mt-2 text-sm text-red-700">
            <summary>Show error details</summary>
            <pre className="mt-2 p-2 bg-white rounded overflow-auto">
              {this.state.error && this.state.error.toString()}
              \nComponent Stack:\n{this.state.componentStack}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
